<template>
    <el-drawer
        title="编辑课程体系"
        :visible.sync="show"
        :wrapperClosable="false"
        direction="rtl"
        size="600px"
        :before-close="close">
        <div class="panel">
            <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                <el-form-item label="体系名称">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="编程语言">
                    <el-select v-model="form.type" placeholder="编程语言" >
                        <el-option
                            v-for="item in lessonTypes"
                            :key="item.optionValue"
                            :label="item.optionText"
                            :value="item.optionValue">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="体系类型">
                    <el-select v-model="form.useType" clearable placeholder="编程语类型言">
                        <el-option label="通用体系" :value="1"></el-option>
                        <el-option label="充值体系" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标签">
                    <el-input v-model="form.tags" placeholder="多个标签用 ，隔开"></el-input>
                </el-form-item>
                <el-form-item label="适用范围">
                    <el-input v-model="form.suitCrowd"></el-input>
                </el-form-item>
                <el-form-item label="封面">
                    <el-upload
                        class="photo_uploader"
                        action=""
                        accept="image/*"
                        :show-file-list="false"
                        :before-upload="uploadCover">
                        <img v-if="form.coverImg != null" :src="form.coverImg" class="avatar">
                        <i v-else class="el-icon-plus uploader-icon"></i>
                    </el-upload>

                </el-form-item>
                <el-form-item label="简介">
                    <el-input
                        type="textarea"
                        placeholder="请输入内容"
                        v-model="form.introduction"
                        maxlength="255"
                        :rows="5"
                        show-word-limit
                    >
                    </el-input>
                </el-form-item>
            </el-form>

        </div>
        <span  class="fx fx-center">
            <el-button type="primary" @click="sub()">保 存</el-button>
            <el-button @click="close()">关 闭</el-button>
        </span>
    </el-drawer>
</template>

<style scoped>

</style>


<script>


    export default {
        props: [
            "item",
        ],
        data() {
            return {
                show: false,
                form: {...this.item},
                lessonTypes: [],
            }

        },


        methods: {
            close() {
                this.$emit("close");
            },
            sub() {
                this.$ajaxPost("/lessonSystem/save", {
                    lessonSystem: this.form
                }, (data) => {
                    this.$emit("submit", data.result);
                })
                return false;
            },
            loadLessonTypes() {
                this.$ajaxGet("/common/lessonType", (data) => {
                    this.lessonTypes = data.result;
                })
            },
            uploadCover(file) {
                this.$uploadQiniu(file, "lessonsystem/", {
                        success: (file) => {
                            this.form = Object.assign({}, this.form, {coverImg: file.url});
                        }
                    }
                )

                return false;
            },

        },
        mounted() {
            this.show = true;
        },
        created() {
            this.loadLessonTypes();
        }


    }
</script>
